import { graphql } from '@/gql';
import type { FindCallerPhoneNumberByExternalPartnerCallerIdQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

type FindCallerPhoneNumberByExternalPartnerCallerIdInput = FindCallerPhoneNumberByExternalPartnerCallerIdQueryVariables;

export const findCallerPhoneNumberByExternalPartnerCallerId = async ({
  partnerId,
  externalPartnerCallerId,
}: FindCallerPhoneNumberByExternalPartnerCallerIdInput) => {
  const response = await queryExecute({
    query: graphql(`
      query FindCallerPhoneNumberByExternalPartnerCallerId($partnerId: Float!, $externalPartnerCallerId: String!) {
        findCallerPhoneNumberByExternalPartnerCallerId(partnerId: $partnerId, externalPartnerCallerId: $externalPartnerCallerId)
      }
    `),
    variables: {
      externalPartnerCallerId,
      partnerId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.findCallerPhoneNumberByExternalPartnerCallerId;
};
